require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./neighborhood-involvement-locations.json") })
        }
      }, "path---neighborhood-involvement-locations");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---neighborhood-involvement-locations!./.cache/json/neighborhood-involvement-locations.json
// module id = 939
// module chunks = 231608221292675